export default __webpack_public_path__ + "static/media/Icons-40.47f46833.png";